function OnRun($rootScope, AppSettings, toaster,editableOptions, editableThemes, $state) {
  'ngInject';
  $rootScope.breadCrumb = "";
  $rootScope.organizationNameView = true;
  editableThemes.bs3.inputClass = 'input-sm';
  editableThemes.bs3.buttonsClass = 'btn-sm btn-inline';
  editableOptions.theme = 'bs3';
  editableOptions.icon_set = 'font-awesome';
  $rootScope.currentYear = new Date().getFullYear();

  $rootScope.setBaseAndCableUrl = function(){
    var base = document.getElementsByTagName('base');
    base[0].setAttribute('href', AppSettings.baseHref);
    var cableMeta =  document.querySelector('meta[name=action-cable-url]');
    cableMeta.setAttribute('content', AppSettings.wsUrl);
  }
  $rootScope.setBaseAndCableUrl();

  $rootScope.setBreadCrumb = function(){
     $rootScope.breadCrumb = "";
      let states = $state.current.name.split(".");
      let breds = [];
      let nestedState = states[0];
      for(let i=0;i< states.length;i++){
       let currentState =  $state.get(nestedState);
        if(currentState.breadCrumb){
            breds.push({title: currentState.breadCrumb,link: (currentState.redirectTo ? currentState.redirectTo: currentState.name)})
        }
        nestedState = nestedState+ "."+ states[i+1];
      }
      $rootScope.breadCrumb = breds;
  };



  // change page title based on state
  $rootScope.$on('$stateChangeSuccess', (event, toState) => {
    $rootScope.pageTitle = '';
    $rootScope.setBreadCrumb();
    if (toState.title) {
      $rootScope.pageTitle += toState.title;
      $rootScope.pageTitle += ' \u2014 ';
    }

    $rootScope.pageTitle += AppSettings.appTitle;
  });
  // Broadcast ng-token-auth messages
  $rootScope.$on('auth:login-success', function(ev, user) {
    toaster.pop('info','Welcome' + ' ' + (user.name || user.email) + '. ');
  });

  $rootScope.$on('auth:login-error', function(ev, reason) {
    toaster.pop('error',reason.errors[0]);
  });

  $rootScope.$on('auth:logout-success', function(ev) {
    toaster.pop('info',"goodbye");
  });

  $rootScope.$on('auth:logout-error', function(ev, reason) {
    toaster.pop('error',reason.errors[0]);
  });

  $rootScope.$on('auth:email-confirmation-success', function(ev, user) {
    toaster.pop('info', "Welcome, "+user.email+". Your account has been verified.");
  });

  $rootScope.$on('auth:email-confirmation-error', function(ev, reason) {
    toaster.pop('error',"There was an error with your registration.");
  });

  $rootScope.$on('auth:password-reset-request-success', function(ev, data) {
    toaster.pop('info', "Password reset instructions were sent to " + data.email);
  });

  $rootScope.$on('auth:password-reset-request-error', function(ev, resp) {
    toaster.pop('error',"Password reset request failed: " + resp.errors[0]);
  });

  $rootScope.$on('auth:password-reset-confirm-success', function() {
  });
}

export default OnRun;
